import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import {
  VEHICLE_NAME,
  MODEL_NAME,
  MAKE_NAME,
  SUB_TYPE_NAME,
} from 'components/searchAds/constants';
import formValues from 'helpers/form/formValues';
import {
  vehicleDefaultProps,
  vehiclePropTypes,
  FIELD_INDEX,
} from '../../constants';
import SubTypeControl from '../Control';
import mapStateToProps from './mapStateToProps';

class SubTypeField extends PureComponent {
  static propTypes = {
    ...vehiclePropTypes,
    modelValue: PropTypes.string,
    component: elementType,
  };

  static defaultProps = {
    ...vehicleDefaultProps,
    component: SubTypeControl,
    label: __('filterBlocks.titles.subType'),
  };

  render() {
    const { fieldIndex, options, modelValue } = this.props;

    return (
      <Field
        {...this.props}
        name={`${VEHICLE_NAME}.${fieldIndex}.${SUB_TYPE_NAME}`}
        disabled={!options.length || !modelValue}
      />
    );
  }
}

export default formValues(({ fieldIndex = FIELD_INDEX }) => ({
  makeValue: `${VEHICLE_NAME}.${fieldIndex}.${MAKE_NAME}`,
  modelValue: `${VEHICLE_NAME}.${fieldIndex}.${MODEL_NAME}`,
  subTypeValue: `${VEHICLE_NAME}.${fieldIndex}.${SUB_TYPE_NAME}`,
}))(connect(mapStateToProps)(SubTypeField));
